<div class="cw-layout">
  <app-workbench-header [jobsMenu]="jobsMenu()" [invoicesMenu]="invoicesMenu()"></app-workbench-header>

  <main class="cw-layout__main" [attr.aria-labelledby]="mainAriaLabelledby()">
    @if (breadcrumb(); as crumb) {
      <app-workbench-breadcrumb
        [title]="crumb.title ?? ''"
        [subtitle]="crumb.subtitle ?? ''"
        [upperSubtitle]="crumb.upperSubtitle ?? ''"
        [breadcrumbItems]="crumb.breadcrumbItems ?? []"
      ></app-workbench-breadcrumb>
    }
    <ng-content></ng-content>
  </main>

  <app-workbench-footer></app-workbench-footer>
</div>
